const localePt = {
  pt: {
    LANDING_TITLE1: '¡{{name}},\ndamos as boas-vindas a você\n',
    LANDING_TITLE2: 'Crehana!',
    LANDING_COPY:
      'Somos a plataforma aliada da {{ORG}} que potencializará seu crescimento profissional e pessoal.',
    LANDING_START: 'Conheça meu painel',

    HEADER_BREADCRUMB_TITLE_1: 'Bem-vindo',
    HEADER_BREADCRUMB_TITLE_2: 'Saber mais',
    HEADER_BREADCRUMB_TITLE_3: 'Recursos',

    STEPPER_NEXT: 'Prosseguir',
    STEPPER_BACK: 'Atrás',

    FEATURE_TITLE: 'O que temos para você',
    FEATURE_TITLE_1: 'Projete sua experiência',
    FEATURE_DESCRIPTION_1:
      'Personalize suas informações para acessar oportunidades de aprendizado e desenvolvimento mais relevantes para você.',
    FEATURE_TITLE_2: 'Impulsione seu crescimento',
    FEATURE_DESCRIPTION_2:
      'Acesse conteúdos de formação e aprendizagem projetados para potencializar suas habilidades e acompanhá-lo em sua evolução profissional. *',
    FEATURE_TITLE_3: 'Envolva-se em seu desenvolvimento',
    FEATURE_DESCRIPTION_3:
      'Seja parte ativa de avaliações, reconhecimentos e outros processos que fortalecem seu desenvolvimento e o de sua equipe. *',
    FEATURE_INFO: '* De acordo com os produtos que sua empresa comprou',

    RESOURCES_TITLE: 'Ajuda e recursos',
    RESOURCES_SUBTITLE_1: 'Chatbot',
    RESOURCES_DESCRIPTION_1:
      'Em nossa plataforma, temos um chat de suporte para aconselhá-lo sobre o uso da plataforma.',
    RESOURCES_SUBTITLE_2: 'Central de Ajuda',
    RESOURCES_DESCRIPTION_2:
      'Quando precisar de guias ou tutoriais, você também pode acessar a opção “Ajuda”.',

    POWERED_BY: 'Powered by',
  },
};

export default localePt;
